/** Массив хранящий все загруженные роуты (с доп.информацией) */
export const setRouteArr = (routeArr) => {
  return {type: 'SET_ROUTE_ROUTE_ARR', payload:routeArr};
};
/** Массив нвстройки роутов (показ, цвет и т.д.) */
export const setRouteSettingsArr = (routeSettingsArr) => {
  return {type: 'SET_ROUTE_ROUTE_SETTINGS_ARR', payload:routeSettingsArr};
};
/** Массив нвстройки роутов (показ, цвет и т.д.) */
export const setRoutePaletteStatus = (paletteStatus) => {
  return {type: 'SET_ROUTE_PALETTE_STATUS', payload:paletteStatus};
};
